import React from "react";
import config from "../../../config";

export default function GooglePlayStoreLink({ href }: { href: string }) {
  const googlePlayStoreImageUrl = `${config.ASSETS_URL}/static/google-play-badge-2025.png`;
  return (
    <a href={href} target='_blank' rel='noopener noreferrer'>
      <img className='tw-h-[40px]' src={googlePlayStoreImageUrl} alt='Get it on Google Play' />
    </a>
  );
}
